import { render, staticRenderFns } from "./Clause.vue?vue&type=template&id=33598235&"
import script from "./Clause.vue?vue&type=script&lang=js&"
export * from "./Clause.vue?vue&type=script&lang=js&"
import style0 from "./Clause.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Clause.vue"
export default component.exports